// extracted by mini-css-extract-plugin
module.exports = {"error":"accountform_error__fsUC_"};